import { render } from "./TrainingSectionGallery.vue?vue&type=template&id=31d5d7f8&scoped=true"
import script from "./TrainingSectionGallery.vue?vue&type=script&lang=js"
export * from "./TrainingSectionGallery.vue?vue&type=script&lang=js"

import "./TrainingSectionGallery.vue?vue&type=style&index=0&id=31d5d7f8&lang=scss&scoped=true"

import exportComponent from "/var/www/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31d5d7f8"]])

export default __exports__